import { Fragment } from "react";

import Head from "next/head";
import Script from "next/script";

import TypeformPage from "../../components/TypeformPage";

export const BookDemo = () => {
  return (
    <Fragment>
      <Head>
        <title>QuickSell | Book Demo</title>
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      </Head>
      <Script src="https://embed.typeform.com/next/embed.js" strategy="afterInteractive" />
      <TypeformPage typeformId="xjdF67jh" onTypeformSubmit="onTypeformSubmit" />
    </Fragment>
  );

};

export default BookDemo;
